export default __webpack_public_path__ + "static/media/cp_geo_bt.7b92eb4c.svg";